import { Box } from '@mui/system'
import { memo } from 'react'
import Header from '../../components/Header'
import Navigation from '../../components/Navigation'
import { LayoutFor } from '../../types'

const MainHeader = ({ layoutFor }: { layoutFor: LayoutFor }) => {
  const isDamageDuringRoute = layoutFor === LayoutFor.DAMAGE_DURING_ROUTE
  return (
    <Box
      position={isDamageDuringRoute ? 'static' : 'fixed'}
      width="100%"
      zIndex="10"
      top={0}
    >
      <Header />
      {/* Show navigation only if not in DAMAGE_DURING_ROUTE layout */}
      {!isDamageDuringRoute && <Navigation />}
    </Box>
  )
}
export default memo(MainHeader)
